import { useQuery } from '@tanstack/react-query';
import { fetchCohort } from './cohorts.ts';

export interface CohortInOrganisation {
  /** The cohort, or undefined when it belongs to another organisation. */
  cohort: string | undefined;
  /** False while the cohort is still being read. */
  settled: boolean;
}

/*
 * A cohort named in the URL counts only while it belongs to the header's organisation:
 * a link, or a choice made before the header changed, can name another one's.
 * Undefined `organisationId` means every organisation, so any cohort counts.
 */
export function useCohortInOrganisation(
  cohort: string | undefined,
  organisationId: string | undefined,
): CohortInOrganisation {
  const record = useQuery({
    queryKey: ['cohort', cohort],
    queryFn: () => fetchCohort(cohort!),
    enabled: cohort !== undefined && organisationId !== undefined,
  });

  if (cohort === undefined) return { cohort: undefined, settled: true };
  if (organisationId === undefined) return { cohort, settled: true };
  if (record.isPending) return { cohort: undefined, settled: false };

  return {
    cohort: record.data?.organisation_id === organisationId ? cohort : undefined,
    settled: true,
  };
}
